export enum UserStatusEnum {
  OnApproval = 1,
  Active = 2,
  Blocked = 3,
  Deleted = 4,
}
